export default __webpack_public_path__ + "static/media/CaneControllerMS.f6ef013d.png";